module.exports = __webpack_public_path__ + "img/logoWhite.9f5dbd6e.svg";